<template>
  <div class="Description">
    <h1 class="heading">
      <p class="heading-top">{{ c.headingTop }}</p>
      {{ c.heading }}
    </h1>
    <h3 class="sub-heading">{{ c.subHeading }}</h3>
    <router-link to="/forecast" class="btn">{{ c.btnText }}</router-link>
    <div class="policy-container">
      <p v-for="(p, i) in settings.policy" :key="i">
        {{ p }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data(){return {
    c: this.$parent.content[0],
    settings: this.$parent.content[3],
  }}
}
</script>

<style lang="scss" scoped>
@import '@/assets/main.scss';

.Home .Description {
  transform: translateX(-50%);
  opacity: 1;
  animation: changeOpacity 1.5s ease 0s 1;
  padding: 15px;
  
  height: auto;
  overflow-y: visible;
}

.Description {
  z-index: 999;
  position: absolute;
  left: 50%;
  top: 0;
  transition: all 0.5s ease, opacity 0.5s ease;
  transform: translateX(-150%);
  opacity: 0;
  max-width: 630px;
  width: 100%;
  height: 90vh;
  overflow: hidden;
  padding: 0;
  margin: 0;
  .heading {
    transform: translateY(0px);
    animation: moveFromDown 1.5s ease 0s 1;
    font-family: 'Rubik';
    font-size: 48px;
    font-weight: 700;
    line-height: 57px;
    letter-spacing: 0em;
    .heading-top {
      font-family: 'Raleway', sans-serif;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      margin-bottom: 60px;
    }
  }
  .sub-heading {
    transform: translateY(0px);
    animation: moveFromDown 1.5s ease 0s 1;
    font-family: 'Rubik', sans-serif;
    font-size: 22px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: 0em;
    margin-top: 11px;
  }
  .btn {
    transform: translateY(0px);
    animation: moveFromDown 1.5s ease 0s 1,
      bounce 3s cubic-bezier(0.39, 0.575, 0.565, 1) 1.5s infinite;
    font-family: 'Raleway', sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: center;
    text-decoration: none;
    color: $white;
    box-shadow: 8px 8px 20px rgba(36, 36, 36, 0.2);
    border-radius: 50px;
    border: none;
    display: inline-block;
    padding: 12px 20px;
    margin-top: 60px;
    background: $btn_grad_1;
  }
  .policy-container {
    margin-top: 125px;
    font-family: Rubik;
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    color: rgba(0, 0, 0, 0.7);
  }
}

@keyframes changeOpacity {
  0% { opacity: 0 }
  100% { opacity: 1 }
}
@keyframes moveFromDown {
  0% { transform: translateY(10px) }
  100% { transform: translateY(0px) }
}
@keyframes bounce {
  0% { transform: translateY(0px) }
  100% { transform: translateY(0px) }
  50% { transform: translateY(-5px) }
}

</style>